<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Operadores"
      icono="mdi-account-key"
      tabla-vista="ope"
      busqueda-rapida
      titulo-crud="operador"
      permitir-anadir
      permitir-modificar
      permitir-eliminar

      :variables="misVariables"
      :filtro-registros="filtroRegistros"
      :key="filtroRegistros"      
      :evento-antes-abrir-formulario-datos="antesAbrirFormularioDatos"
      :evento-antes-guardar-formulario-datos="antesGuardarFormularioDatos"
      :evento-cambio-selector-items="cambioSelectorItems"
      >

      <template v-slot:item.nom="{ item }">
          {{ item.nom }}
          <span v-if="item.blo != 0"><v-icon color="orange">mdi-lock</v-icon></span>
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosOperadores.vue";
import CONSTANTES_CRUD from "@/constantesCRUD"

export default {
  components: { TablaDatosAPI },
  
   data: () => ({
    misVariables: null,
  }), 

  computed: {
    filtroRegistros () {
      console.log('filtroRegistros');
      let filtro = "1=1";

      /* se aplica un filtro para mostrar los usuarios cuyo rol sea igual o inferior 
         al de la persona logada  */
      filtro += " AND id_rolope <= " + this.$store.state.operador.idRol;
      
      /* se aplica un filtro para los operadores de la instalacion 
         a la que pertenece el usuario logado. Si se trata de un Administrador Equinsa 
         no hay filtrado */      
      if (null != this.$store.state.operador.instalacion.id_ins)  { 
        filtro += " AND id_ins = " + this.$store.state.operador.instalacion.id_ins; 
      }

      return filtro;
    }, // fin filtroRegistros

  }, // fin computed

  methods: {

    antesAbrirFormularioDatos: function(accionCRUD) {
      console.log('antesAbrirFormularioDatos');
      console.log(accionCRUD);
      //componente.DatosRegistro.corele='yuyu@pop.po';
    }, // fin metodo  antesabrirFormularioDatos


    antesGuardarFormularioDatos: function(accionCRUD, registro) {
      console.log('antesguardarFormularioDatos');
      console.log(accionCRUD);

      /* establezco el identificador de la instalacion a la que pertenecerá el nuevo usuario
        (la misma del usuario logado) */
//      registro.id_ins = this.$store.state.operador.instalacion.id_ins;

      if (accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) {
        console.log('CRUD.ACCION.CREATE');
        registro.id_ins = this.$store.state.operador.instalacion.id_ins;
      }  

      console.log(registro);
    }, // fin metodo  antesGuardarFormularioDatos

    cambioSelectorItems: function() {
      console.log('cambioSelector');
    }, // fin metodo  antesGuardarFormularioDatos


  }, // fin methods
  

  mounted () {

      if (null != this.$store.state.operador.instalacion.id_ins)  { 

        console.log(this.$store.state.operador);
        this.misVariables = {
          "id_empinq": {
            "dominio_valores_sql": 
              "SELECT id_empinq AS v, nom AS d FROM empinq WHERE id_ins=" + 
              this.$store.state.operador.instalacion.id_ins + 
              " UNION SELECT NULL AS v, '(Ninguna)' AS d"
          },

          "id_rolope": {
            "dominio_valores_sql": 
              "SELECT id_rolope AS v, des AS d FROM c_rolope WHERE id_rolope <=" + 
              this.$store.state.operador.idRol
          },

        }  
      }
  } // fin mounted
};
</script>

<style>
</style>